import { KTX2Loader } from 'three-stdlib';

// Wire a KTX2Loader into drei's useGLTF so GLBs whose textures were encoded to
// KTX2/Basis (ETC1S) — see scripts/optimize_models.mjs — transcode in-browser to
// each device's native GPU format and STAY compressed in VRAM (4–8× less than the
// RGBA that WebP/PNG decode to). The Basis transcoder (js + wasm) is served from
// /basis/ (copied into public/basis/ from three's examples). Inert on GLBs that
// have no KTX2 textures, so it's safe to attach on every load, KTX2 or not.
//
// detectSupport() needs the live WebGLRenderer, so callers pass useThree's `gl`
// and should memoize on it (useMemo([gl])) — the loader is a shared singleton.
let loader = null;

export function ktx2Extend(gl) {
  if (!loader) loader = new KTX2Loader().setTranscoderPath('/basis/');
  loader.detectSupport(gl);
  return (gltfLoader) => gltfLoader.setKTX2Loader(loader);
}
